<template>
<v-list-tile>
  <v-menu
      ref="menuStart"
      v-model="menuStart"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
  >
      <template v-slot:activator="{ on }">
      <v-text-field
          :value="value.start"
          label="Início"
          prepend-icon="access_time"
          readonly
          v-on="on"
      ></v-text-field>
      </template>
      <v-time-picker
      v-if="menuStart"
      :value="value.start"
      ref="startPicker"
      full-width
      format="24hr"
      @change="updateStart"
      @click:minute="$refs.menuStart.save(value.start)"
      ></v-time-picker>
  </v-menu>
  <v-spacer></v-spacer>
  <v-menu
      ref="menuEnd"
      v-model="menuEnd"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
  >
      <template v-slot:activator="{ on }">
      <v-text-field
          :value="value.end"
          label="Fim"
          prepend-icon="access_time"
          readonly
          v-on="on"
      ></v-text-field>
      </template>
      <v-time-picker
      v-if="menuEnd"
      ref="endPicker"
      :value="value.end"
      full-width
      format="24hr"
      @change="updateEnd"
      @click:minute="$refs.menuEnd.save(value.end)"
      ></v-time-picker>
  </v-menu>
  <v-spacer></v-spacer>
  <v-list-tile-action>
    <v-btn icon flat @click="$emit('delete')"><v-icon>close</v-icon></v-btn>
  </v-list-tile-action>
</v-list-tile>
</template>

<script>
export default {
  props:['value'],
  data() {
    return {
      menuStart:false,
      menuEnd:false,
    }
  },
  methods:{
    updateStart(v){
      this.$emit('input', {
        start: v,
        end: this.value.end
      })
    },
    updateEnd(v){
      this.$emit('input', {
        start: this.value.start,
        end: v
      })
    },
  }
}
</script>

<style>

</style>